import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=c4fd177c&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=c4fd177c&prod&lang=less"
import style1 from "./detail.vue?vue&type=style&index=1&id=c4fd177c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fd177c",
  null
  
)

export default component.exports